// extracted by mini-css-extract-plugin
export default {"Textarea":"Textarea_Textarea_jcAlt","disabled":"Textarea_disabled_XzqPp"};